import { Table as AntdTable } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { DraggableTableRow } from 'components/ui/Table/DraggableTableRow';
import { DictionarySettingsStore } from 'stores/models/fieldsSettings';
import { noop } from 'utils/noop';

import { DictionaryTableProvider } from './context';
import { useCreateDictionaryTable } from './hooks';

import './DictionaryTable.scss';

type DictionaryTableProps = {
  store: DictionarySettingsStore;
};

const wrappers = {
  body: {
    row: DraggableTableRow,
  },
};

const DictionaryTable: React.FC<DictionaryTableProps> = ({ store }) => {
  const columns = useCreateDictionaryTable(store);

  const onRow = React.useCallback(
    (_, index: number) => {
      return {
        moveRow: (oldIndex, newIndex) => {
          store.onSortEnd({ oldIndex, newIndex });
        },
        onClick: noop,
        index,
      };
    },
    [store]
  );

  return (
    <DictionaryTableProvider store={store}>
      <DndProvider backend={HTML5Backend}>
        <AntdTable
          columns={columns}
          dataSource={store.values}
          pagination={false}
          onRow={onRow}
          loading={store.dictionaryGetRequest.loading}
          rowKey="id"
          components={wrappers}
        />
      </DndProvider>
    </DictionaryTableProvider>
  );
};

export default observer(DictionaryTable);
